exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".verify-token[data-v-2be6c299]{position:relative}.verify-token p[data-v-2be6c299]{position:absolute;left:0;right:0;bottom:50px}p.text-center.loaded[data-v-2be6c299]{bottom:0;position:relative;margin-top:80px}.anynomous-header[data-v-2be6c299]{-webkit-box-shadow:0 0 5px #e5e5e5;box-shadow:0 0 5px #e5e5e5}", ""]);

// exports
